import React, { memo, useState } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
const FullfillmentDialog = memo(({ handleClose, customArt }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const renderTooltip = (props) => (
    <Tooltip id="custom-tooltip" className="custom-tooltip" {...props}>
      Lorem is a vibrant community nestled in the heart of the Emerald Valley,
      known for its lush landscapes and rich cultural heritage. The town is
      famous for its annual...
    </Tooltip>
  );
  console.log("customArt", customArt)
  return (
    <>
      <div className="text-left d-flex justify-content-between align-items-center">
        <p className="mb-0 artwork-details text-left">Fulfillment Details</p>

        <img
          src="../../images/svg/closeIconDialog.svg"
          className="details-cross"
          alt="Close"
          onClick={handleClose}
          style={{ cursor: "pointer" }}
        />
      </div>
      <hr />
      <div className="row">
        <div className="col-md-3">
          <p className="artist-name">Artist Name</p>
        </div>
        <div className="col-md-9">
          <p className="artist-name1">Deepak Kumar</p>
        </div>
      </div>

      <div className="row">
        <div className="col-md-3">
          <p className="artist-name">Time to Fulfill</p>
        </div>
        <div className="col-md-9">
          <p className="artist-name1">5 Days</p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 d-flex align-items-center">
          <p className="artist-name">Start Date - </p>
          <p className="artist-name1 ms-2"> 24 July 2025</p>
        </div>

        <div className="col-md-4 d-flex align-items-center">
          <p className="artist-name1">End Date - </p>
          <p className="artist-name1 ms-2"> 29 July 2025</p>
        </div>

        <div className="col-md-4 d-flex align-items-center">
          <p className="artist-name1">Amount - </p>
          <p className="artist-name1 ms-2"> 5000</p>
        </div>
      </div>
      <hr />
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <p
            className="artist-name"
            style={{ position: "relative", display: "inline-block" }}
          >
            50% Before Work Begins{" "}
            <span
              style={{ cursor: "pointer", fontWeight: "bold" }}
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
           <i class="fa-regular fa-circle-exclamation"></i>
            </span>
            {showTooltip && (
              <div
                style={{
                  position: "absolute",
                  bottom: "-5rem",
                  left: "150%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#e3f2fd",
                  color: "#000",
                  fontWeight:"500 !important",
                  padding: "10px 12px",
                  borderRadius: "10px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  fontSize: "13px",
                  width: "25rem",
                  zIndex: 999,
                  whiteSpace: "normal",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-8px",
                    left: "23%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "6px solid transparent",
                    borderRight: "6px solid transparent",
                    borderBottom: "8px solid #e3f2fd",
                  }}
                />
                Lorem is a vibrant community nestled in the heart of the Emerald
                Valley, known for its lush landscapes and rich cultural
                heritage. The town is famous for its annual...
              </div>
            )}
          </p>

          <p className="artist-name1">$250</p>
        </div>
        <div>
          <button className="details-artwork-btn">Pay Now</button>
        </div>
      </div>
      <hr />
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <p className="artist-name">50% Delivery/Work Completion  <i class="fa-regular fa-circle-exclamation"></i></p>
          <p className="artist-name1">$250</p>
        </div>
        <div>
          <button className="details-artwork-btn" disabled>
            Pay Now
          </button>
        </div>
      </div>
      <hr />
      <div className="ms-auto">
        <button className="contact-support-button ">Contact Support</button>
      </div>
    </>
  );
});

export default FullfillmentDialog;
